import React, { forwardRef } from "react";
import accessibleDropdown from "../AccessibleDropdown/AccessibleDropdown";
import { Link } from "react-router-dom";

const ReportsMenuList = forwardRef(
  (
    {
      menuItems,
      itemRefs,
      isOpen,
      handleItemKeyDown,
      handleMenuItemClick,
      restrictHover,
      accessibilityValues,
      handleClick,
      popupClassName = { open: "", close: "", wrapperClass: "" },
    },
    ref,
  ) => {
    return (
      <div
        className={`popup_menu ${isOpen ? popupClassName.open : popupClassName.close}`}
      >
        <div
          id={accessibilityValues.ariaControls}
          role={accessibilityValues.ariaHaspopup}
          aria-label={accessibilityValues.ariaLabel}
          aria-labelledby={accessibilityValues.buttonId}
          ref={ref}
          className="reports_listitem_container report_button_animation"
        >
          {menuItems?.map((menuItem, index) => {
            return (
              <Link
                aria-hidden={!isOpen}
                key={menuItem?.key}
                ref={(el) => (itemRefs.current[index] = el)}
                role="menuitem"
                to={menuItem.navigateTo}
                state={{
                  from: menuItem?.key,
                }}
                onKeyDown={(e) => {
                  handleItemKeyDown(e, index);
                }}
                className="listitem with_btn reports-list-item"
                onClick={() => handleClick()}
              >
                <div className="list_btn">
                  <span className="listitem_text">{menuItem?.heading}</span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    );
  },
);

export default accessibleDropdown(ReportsMenuList);
